'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';

import { captureAttribution } from '@shared/utils/attribution';

function AttributionCaptureInner() {
  const searchParams = useSearchParams();

  useEffect(() => {
    captureAttribution(new URLSearchParams(searchParams.toString()));
  }, [searchParams]);

  return null;
}

/**
 * 유입 파라미터(UTM 5개 + gclid/fbclid) 캡처 — localStorage 30일 스냅샷.
 *
 * `AppProviders` 에 전역 마운트되어 모든 페이지 진입에서 동작한다.
 */
export function AttributionCapture() {
  return (
    <Suspense fallback={null}>
      <AttributionCaptureInner />
    </Suspense>
  );
}
